import type { CustomFieldValue } from '@fukuri-admins/apis/client/gen/model';

/**
 * カスタムフィールド値を label をキーとした Record に展開する
 *
 * - 複数値がある場合はカンマ結合する
 * - API レスポンスの `custom_field_values[].label` が存在する前提で動作する
 * - label が空文字・null・undefined の要素は無視する
 *
 * ## 前提・制約
 * `client.custom_field_values[]` の各要素には `label` しか `CustomFieldDefinition` との
 * 結合キーが存在しない（ID 結合が API 設計上できない）。
 * この関数は label を `custom_field_${label}` キーに変換するのみで、
 * `CustomFieldDefinition` との突き合わせは行わない。
 * 突き合わせは `formatCustomFieldValues` が一元的に担う。
 *
 * @param customFieldValues カスタムフィールド値の配列
 * @returns `{ custom_field_${label}: value }` 形式の Record
 */
export const extractCustomFields = (
  customFieldValues: CustomFieldValue[]
): Record<string, string> => {
  return customFieldValues.reduce(
    (acc, field) => {
      if (!field.label) return acc;

      const key = `custom_field_${field.label}`;
      const value = String(field.value);

      const existing = acc[key];
      if (existing) {
        acc[key] = `${existing},${value}`;
      } else {
        acc[key] = value;
      }

      return acc;
    },
    {} as Record<string, string>
  );
};
